exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor[data-v-2e6a087f]{cursor:pointer}.right[data-v-2e6a087f]{float:right}.media-nps[data-v-2e6a087f]{display:block;margin-top:20px;color:#3598dc!important;font-weight:700;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e6a087f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/onboarding/listEvaluationOnboarding.vue
// module id = 1496
// module chunks = 0